import React, { useState } from 'react';
import { HelpCircle, Mail, Phone, MessageCircle, ChevronDown, X, Send } from 'lucide-react';
import { contactAPI } from '../services/api';
import './Support.css';

const Support = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    { type: 'bot', text: 'Bună! Sunt asistentul virtual. Cu ce te pot ajuta?' }
  ]);
  const [chatInput, setChatInput] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const faqs = [
    {
      question: 'Cum funcționează plata per cursă?',
      answer: 'Descarcă aplicația mobilă, adaugă un card bancar sau Apple Pay/Google Pay. La fiecare călătorie, aplicația detectează automat când urci în autobuz și taxează automat prețul cursei în funcție de distanța parcursă.'
    },
    {
      question: 'Cum validez biletul în autobuz?',
      answer: 'Nu este nevoie de validare manuală! Aplicația folosește tehnologia NFC și localizare GPS pentru a detecta automat când urci în autobuz și pentru a marca începutul călătoriei. Doar asigură-te că ai aplicația instalată și un card de plată adăugat.'
    },
    {
      question: 'Ce metode de plată acceptați?',
      answer: 'Acceptăm card bancar (Visa, Mastercard), Apple Pay și Google Pay pentru toate tranzacțiile. Plățile sunt procesate automat după fiecare cursă efectuată.'
    },
    {
      question: 'Ce tip de abonamente oferiți?',
      answer: 'Oferim Abonamente Lunare care permit călătorii nelimitate pentru 30 de zile. Poți achiziționa abonamentul direct din aplicație.'
    },
    {
      question: 'Cum pot vedea istoricul călătoriilor mele?',
      answer: 'În aplicație, accesează secțiunea "Istoric" pentru a vedea toate călătoriile efectuate, distanțele parcurse, costurile și rutele folosite. Poți exporta și istoricul pentru evidențe personale.'
    },
    {
      question: 'Ce se întâmplă dacă uit telefonul acasă?',
      answer: 'Pentru a călători cu sistemul nostru, ai nevoie de aplicația mobilă activă pe telefon. Recomandăm să ai întotdeauna telefonul cu tine și să te asiguri că bateria este suficient încărcată.'
    },
    {
      question: 'Cum pot urmări autobuzul în timp real?',
      answer: 'În aplicație, accesează secțiunea "Harta Live" și selectează linia dorită pentru a vedea poziția în timp real a autobuzelor, timpul estimat de sosire la stație și gradul de ocupare.'
    },
    {
      question: 'Ce fac dacă am fost taxat greșit?',
      answer: 'Dacă observi o eroare în taxare, contactează-ne imediat prin aplicație sau pe email. Vom verifica călătoria în sistemul nostru și vom returna suma dacă identificăm o eroare.'
    }
  ];

  const handleChatSubmit = (e) => {
    e.preventDefault();
    if (!chatInput.trim()) return;

    // Add user message
    const userMessage = { type: 'user', text: chatInput };
    setChatMessages(prev => [...prev, userMessage]);

    // Simple bot response logic
    setTimeout(() => {
      let botResponse = '';
      const input = chatInput.toLowerCase();

      if (input.includes('bilet') || input.includes('cumpăr')) {
        botResponse = 'Pentru a cumpăra bilete, descarcă aplicația noastră mobilă din App Store sau Google Play. Poți plăti per cursă sau achiziționa un abonament lunar.';
      } else if (input.includes('plată') || input.includes('card')) {
        botResponse = 'Acceptăm card bancar (Visa, Mastercard), Apple Pay și Google Pay. Plata se face automat după fiecare cursă efectuată.';
      } else if (input.includes('abonament')) {
        botResponse = 'Oferim Abonamente Lunare cu călătorii nelimitate pentru 30 de zile. Le poți achiziționa direct din aplicație.';
      } else if (input.includes('aplicație') || input.includes('download')) {
        botResponse = 'Descarcă aplicația din App Store pentru iOS sau Google Play pentru Android. Caută "Multipower Transport".';
      } else if (input.includes('orar') || input.includes('program')) {
        botResponse = 'Poți vedea orarul complet al rutelor în aplicația mobilă sau pe pagina "Rute" de pe site.';
      } else if (input.includes('contact') || input.includes('telefon')) {
        botResponse = 'Ne poți contacta la +40740824224 (Luni-Vineri 08:00-20:00) sau pe email la contact@transport.ro';
      } else {
        botResponse = 'Îți mulțumesc pentru întrebare! Pentru informații detaliate, te rog să consulți secțiunea FAQ sau să ne contactezi la contact@transport.ro';
      }

      setChatMessages(prev => [...prev, { type: 'bot', text: botResponse }]);
    }, 500);

    setChatInput('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await contactAPI.sendMessage(formData);
      alert('Mesajul a fost trimis cu succes!');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      alert('Eroare la trimiterea mesajului. Te rugăm să încerci din nou.');
    }
  };

  return (
    <div className="support-page">
      <section className="support-hero">
        <div className="container">
          <h1 className="page-title">Suport Clienți</h1>
          <p className="page-subtitle">Suntem aici să te ajutăm cu orice întrebare</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-methods">
            <div className="contact-card card">
              <Phone size={32} />
              <h3>Telefon</h3>
              <p>Luni - Vineri: 08:00 - 20:00</p>
              <a href="tel:+40740824224">+40740824224</a>
            </div>
            <div className="contact-card card">
              <Mail size={32} />
              <h3>Email</h3>
              <p>Răspundem în 24h</p>
              <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a>
            </div>
            <div className="contact-card card">
              <MessageCircle size={32} />
              <h3>Chat Live</h3>
              <p>Disponibil 24/7</p>
              <button className="btn btn-primary" onClick={() => setChatOpen(true)}>Deschide Chat</button>
            </div>
          </div>

          <div className="faq-section">
            <h2 className="section-title">Întrebări Frecvente</h2>
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div key={index} className="faq-item card">
                  <button
                    className="faq-question"
                    onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                  >
                    <HelpCircle size={20} />
                    <span>{faq.question}</span>
                    <ChevronDown
                      size={20}
                      className={`faq-icon ${activeIndex === index ? 'faq-icon-active' : ''}`}
                    />
                  </button>
                  {activeIndex === index && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="contact-form-section">
            <h2 className="section-title">Trimite-ne un Mesaj</h2>
            <form onSubmit={handleSubmit} className="contact-form card">
              <div className="form-grid">
                <input
                  type="text"
                  placeholder="Nume"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  required
                />
              </div>
              <input
                type="text"
                placeholder="Subiect"
                value={formData.subject}
                onChange={(e) => setFormData({...formData, subject: e.target.value})}
                required
              />
              <textarea
                placeholder="Mesaj"
                rows={6}
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                required
              />
              <button type="submit" className="btn btn-primary btn-large">
                Trimite Mesaj
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Chat Widget */}
      {chatOpen && (
        <div className="chat-widget">
          <div className="chat-header">
            <div className="chat-header-info">
              <MessageCircle size={20} />
              <span>Chat Live</span>
            </div>
            <button className="chat-close" onClick={() => setChatOpen(false)}>
              <X size={20} />
            </button>
          </div>
          <div className="chat-messages">
            {chatMessages.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.type}`}>
                <div className="message-bubble">{msg.text}</div>
              </div>
            ))}
          </div>
          <form className="chat-input-form" onSubmit={handleChatSubmit}>
            <input
              type="text"
              placeholder="Scrie un mesaj..."
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              className="chat-input"
            />
            <button type="submit" className="chat-send">
              <Send size={20} />
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Support;
